import { render, staticRenderFns } from "./outline-light.vue?vue&type=template&id=ec2202e6"
import script from "./outline-light.vue?vue&type=script&lang=js"
export * from "./outline-light.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports